import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Trophy, Medal, Wallet, ShoppingBag, User, BarChart2 } from "lucide-react";
import { cn } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/home", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/matches", label: "Matches", icon: Trophy, testid: "nav-matches" },
  { to: "/stats", label: "Stats", icon: Medal, testid: "nav-stats" },
  { to: "/ledger", label: "Ledger", icon: Wallet, testid: "nav-ledger", clubAdmin: true },
  { to: "/store", label: "Store", icon: ShoppingBag, testid: "nav-store" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const loc = useLocation();
  const { user, club } = useAuth();
  const isAdmin = !!user?.is_superadmin;
  const isClubAdmin = ["owner", "admin", "manager"].includes(club?.my_role);

  const navItems = items.filter((i) => !i.clubAdmin || isClubAdmin);
  if (isAdmin) {
    navItems.push({ to: "/admin", label: "Admin", icon: BarChart2, testid: "nav-admin" });
  }

  const tight = navItems.length > 5; // superadmins / club admins get extra tabs; keep them on one row

  return (
    <nav
      className="bottom-nav fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-40"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
      data-testid="bottom-nav"
    >
      <ul className={cn("grid pt-2 pb-2", tight ? "px-1" : "px-2")} style={{ gridTemplateColumns: `repeat(${navItems.length}, minmax(0, 1fr))` }}>
        {navItems.map(({ to, label, icon: Icon, testid }) => {
          const active = loc.pathname.startsWith(to);
          return (
            <li key={to}>
              <NavLink
                to={to}
                data-testid={testid}
                className={cn(
                  "flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-2xl transition-colors min-w-0",
                  active ? "text-brand" : "text-ink-muted hover:text-ink"
                )}
              >
                <Icon size={tight ? 20 : 22} strokeWidth={active ? 2.2 : 1.75} />
                <span className={cn("font-semibold max-w-full truncate", tight ? "text-[10px]" : "text-[11px]", active && "text-brand")}>
                  {label}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
